/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const cookieNotice = () => {
  const getCookie = name => {
    const escape = s => {
      return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1');
    }
    const match = document.cookie.match(
      RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'),
    );
    return match ? match[1] : null;
  }

  let d = new Date();
  d.setMonth(d.getMonth() + 1);
  d = d.toGMTString();
  const button = document.querySelector('.js-accept-cookies');
  const popup = document.querySelector('.js-cookies-popup');

  if (!getCookie('cookienotice')) {
    popup.classList.add('is-active');
    button.addEventListener('click', e => {
      e.preventDefault();
      document.cookie = `cookienotice=true; expires=${d}; path=/`;
      setTimeout(() => {
        popup.classList.add('is-fading-out');
        setTimeout(() => {
          popup.classList.remove('is-fading-out');
          popup.classList.remove('is-active');
        }, 280);
      }, 50);
    });
  }
};

export default cookieNotice;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/eco-chisel/src/scripts/modules/cookieNotice.js